/**
 * Resolved application environment.
 * - GKE_ENV is set via Kubernetes env vars: "production" | "staging" (server-only)
 * - NEXT_PUBLIC_RUNTIME_ENVIRONMENT is baked at build time: "production" | "staging"
 *   (available on both server and client)
 * - Locally, defaults to "dev-v2".
 * - Suffixed with "-v2" to distinguish from V1 in shared Sentry/Amplitude accounts.
 */
export type AppEnv = "dev-v2" | "stage-v2" | "prod-v2";

export const APP_ENV: AppEnv = (() => {
  // GKE_ENV is server-only (not NEXT_PUBLIC_), so the client bundle sees undefined.
  // NEXT_PUBLIC_RUNTIME_ENVIRONMENT is inlined at build time and works on both
  // server and client — use it as the primary source.
  const env =
    process.env.GKE_ENV || process.env.NEXT_PUBLIC_RUNTIME_ENVIRONMENT;
  if (env === "production") return "prod-v2";
  if (env === "staging") return "stage-v2";
  return "dev-v2";
})();
